module.exports = __webpack_public_path__ + "static/media/iclusig.22c49a6f.PNG";